export function toNumberBRL(raw: string): number {
  // Aceita: "1234,56" ou "1234.56" ou "1.234,56"
  const cleaned = raw
    .replace(/\s/g, "")
    .replace(/R\$\s?/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
}

export function formatBRLInput(raw: string): string {
  // Máscara: pega somente dígitos e interpreta como centavos.
  // Ex.: "1" => "0,01", "500" => "5,00", "123456" => "1.234,56"
  const digits = (raw ?? "").replace(/\D/g, "");
  if (!digits) return "";
  const cents = Number(digits);
  const value = cents / 100;
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

